import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VFooter, {
    class: [(_vm.isLogged || _vm.forceDark) && "--back-black"]
  }, [_c("div", {
    staticClass: "footer-content no-print"
  }, [_vm._v(" " + _vm._s(new Date().getFullYear()) + " © " + _vm._s(_vm.$whitelabel.brand) + " "), _vm.isTerms ? [_c("span", [_vm._v("|")]), _c("router-link", {
    staticClass: "underlined-link",
    attrs: {
      to: _vm.goToTermsOfUse()
    }
  }, [_vm._v("T.O.U.")]), _c("span", [_vm._v("|")]), _c("router-link", {
    staticClass: "underlined-link",
    attrs: {
      to: _vm.goToTermsOfSales()
    },
    nativeOn: {
      click: function click($event) {
        return _vm.handleAnchorClick();
      }
    }
  }, [_vm._v(" T.O.S. ")]), _c("span", [_vm._v("|")]), _c("router-link", {
    staticClass: "underlined-link",
    attrs: {
      to: _vm.goToTermsOfSales("#privilege-offer")
    },
    nativeOn: {
      click: function click($event) {
        return _vm.handleAnchorClick("privilege-offer");
      }
    }
  }, [_vm._v(" Privilege offer ")]), _vm.isLinkContactShown ? [_c("span", [_vm._v("|")]), _c("router-link", {
    staticClass: "underlined-link",
    attrs: {
      to: _vm.goToContact()
    }
  }, [_vm._v("Contact us")])] : _vm._e()] : _vm._e(), _c("ScrollToTop"), _vm.$route.meta.requireTokenExpiration ? _c("TokenExpirationModal") : _vm._e()], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };